export function getConfig() {
    return window._env_;
}
